export default __webpack_public_path__ + "static/media/fragment.49f9e10d.png";